module.exports = __webpack_public_path__ + "img/landing-img.8503fdf0.png";